module.exports = __webpack_public_path__ + "img/tc／pic.78b1d4e7.png";